<template>
  <div class="payment-form-credit-card">
    <div class="payment-form-credit-card__title">Card Information</div>
    <div class="payment-form-credit-card__elements-wrapper">
      <div class="cart-form__group-wrapper">
        <div class="cart-form__group cart-form__group--short">
          <input
            :type="fields['first name'].type"
            :class="['ine-input', fieldHasError('first name') && 'ine-input--error']"
            :placeholder="fields['first name'].placeholder"
            :autocomplete="fields['first name'].autocomplete"
            :data-recurly="fields['first name']['data-recurly']"
            @focus="clearError('first name')"
            v-model="firstName"
          />
          <span v-if="fieldHasError('first name')" class="ine-input__error-msg">{{
            errors['first name']
          }}</span>
        </div>
        <div class="cart-form__group cart-form__group--short">
          <input
            :type="fields['last name'].type"
            :class="['ine-input', fieldHasError('last name') && 'ine-input--error']"
            :placeholder="fields['last name'].placeholder"
            :autocomplete="fields['last name'].autocomplete"
            :data-recurly="fields['last name']['data-recurly']"
            @focus="clearError('last name')"
            v-model="lastName"
          />
          <span v-if="fieldHasError('last name')" class="ine-input__error-msg">{{
            errors['last name']
          }}</span>
        </div>
      </div>
      <div id="recurly-elements" class="payment-form-credit-card__recurly-elements">
        <div
          id="card-number"
          class="payment-form-credit-card__group payment-form-credit-card__recurly"
        ></div>
        <div class="payment-form-credit-card__group payment-form-credit-card__group--card-date">
          <span>Expiration Date: </span>
          <div id="card-month" class="payment-form-credit-card__recurly"></div>
          /
          <div id="card-year" class="payment-form-credit-card__recurly"></div>
          <div class="payment-form-credit-card__separator" />
          <div
            id="card-cvv"
            class="payment-form-credit-card__group payment-form-credit-card__recurly payment-form-credit-card__recurly--cvv"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { eventsConstants } from '@/helpers/eventsList'
import { mixpanelEvent } from '@/helpers/mixins'

export default {
  name: 'PaymentFormCreditCard',
  mixins: [mixpanelEvent],
  props: {
    fields: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    fieldHasError: {
      type: Function,
      required: true,
    },
    clearError: {
      type: Function,
      required: true,
    },
    cardNumber: { type: Object, required: true },
    cardMonth: { type: Object, required: true },
    cardYear: { type: Object, required: true },
    cardCVV: { type: Object, required: true },
    showCVV: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      steps: ['name', 'number', 'exp', 'cvv'],
      currentStep: 'name',
    }
  },
  computed: {
    ...mapState({
      paymentEntries: state => state.subscriptions.paymentEntries,
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
    firstName: {
      set(input) {
        this.$emit('update-field', { name: 'first name', input })
        this.$store.dispatch('subscriptions/updatePaymentEntries', {
          value: 'firstName',
          input,
        })
      },
      get() {
        return this.paymentEntries.firstName
      },
    },
    lastName: {
      set(input) {
        this.$emit('update-field', { name: 'last name', input })
        this.$store.dispatch('subscriptions/updatePaymentEntries', {
          value: 'lastName',
          input,
        })
      },
      get() {
        return this.paymentEntries.lastName
      },
    },
  },
  methods: {
    handleClick() {
      this.sendMixpanelEvent(eventsConstants.CHECKOUT_CART_UPDATED, {
        trigger: 'completeCreditCard',
      })
      this.$emit('complete')
    },
    handleGoBack() {
      this.$emit('close-modal')
    },
    isBtnDisabled(step) {
      switch (step) {
        case 'name':
          return this.firstName.length === 0 && this.lastName.length === 0
        case 'number':
          return !this.cardNumber.valid
        case 'exp':
          return !this.cardMonth.valid && !this.cardYear.valid
        case 'cvv':
          return !this.cardCVV.valid
        default:
          return true
      }
    },
  },
}
</script>

<style lang="scss">
.payment-form-credit-card {
  width: 100%;
  margin: 15px auto 0 auto;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  &__elements-wrapper {
    width: 100%;
  }
  &__title {
    color: var(--white);
    font-family: var(--font-regular);
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    width: 100%;
    text-align: left;
    margin-bottom: 20px;
  }
  &__group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 15px;
    color: var(--light-blue-gray);
    font-size: 12px;
    align-content: center;
    span {
      color: var(--light-blue-gray);
      font-size: 12px;
      white-space: nowrap;
      font-family: var(--font-regular);
    }
    &--card-date {
      width: 80%;
      margin: unset;
      @include tablet {
        width: 40%;
      }
      @include mobile {
        width: 60%;
      }
    }
  }
  &__recurly {
    width: 100%;
    margin: 0 0 0 0;
    &--disabled {
      opacity: 0;
      height: 0;
      width: 0;
      pointer-events: none;
    }
    &--cvv {
      max-width: 50px;
    }
  }
  &__recurly-elements {
    display: flex;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    input {
      margin-bottom: 15px;
    }
  }
  #card-number {
    margin-bottom: 15px;
  }
  #card-month {
    max-width: 45px;
    margin-right: 5px;
    margin-left: 5px;
  }
  #card-year {
    max-width: 55px;
    margin-left: 5px;
  }
  #card-ccv {
    flex: 1;
    margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid #444444;
  }
  &__separator {
    height: 50px;
    width: 1px;
    overflow: visible;
    position: relative;
    top: 5px;
    border: 1px solid var(--tundora-gray);
  }
}
</style>
